import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';
import { SKELETON_CONSTANTS } from '@components/skeleton/skeleton.constants';

@Component({
  selector: 'app-right-sidebar-skeleton',
  templateUrl: './right-sidebar-skeleton.component.html',
  styleUrls: ['./right-sidebar-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class RightSidebarSkeletonComponent {
  @Input() showAdSkeleton = true;
  @Input() showHeading = false;
  @Input() showStoreSkeleton = true;
  @Input() showViewAllButtonSkeleton = false;

  readonly cardIndices = new Array(
    SKELETON_CONSTANTS.RIGHT_SIDEBAR.STORE_CARD_COUNT
  );
}
